import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@freelancer-os/ui/src/lib/utils';
import { SubscriptionTab } from './components/SubscriptionTab';
import { InvoicesTab } from './components/InvoicesTab';

type Tab = 'subscription' | 'invoices';

export function BillingPage() {
  const { t } = useTranslation('billing');
  const [tab, setTab] = useState<Tab>('subscription');
  return (
    <div className="p-6">
      <h1 className="text-xl font-semibold mb-4">{t('title')}</h1>
      <div className="flex gap-1 border-b border-surface-200 mb-4">
        {(['subscription', 'invoices'] as const).map((k) => (
          <button
            key={k}
            type="button"
            onClick={() => setTab(k)}
            className={cn(
              'px-4 py-2 text-[13px] font-medium border-b-2 -mb-px transition-colors',
              tab === k ? 'border-brand-500 text-brand-700' : 'border-transparent text-surface-500 hover:text-surface-700',
            )}
          >
            {t(`tabs.${k}`)}
          </button>
        ))}
      </div>
      {tab === 'subscription' ? <SubscriptionTab /> : <InvoicesTab />}
    </div>
  );
}
